module.exports = __webpack_public_path__ + "static/media/chevron-up.3bbe9681.svg";